import { render, staticRenderFns } from "./ViewEvent.vue?vue&type=template&id=7cd64366&scoped=true"
import script from "./ViewEvent.vue?vue&type=script&lang=js"
export * from "./ViewEvent.vue?vue&type=script&lang=js"
import style0 from "./ViewEvent.vue?vue&type=style&index=0&id=7cd64366&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd64366",
  null
  
)

export default component.exports